import { Component, inject, OnInit } from '@angular/core';
import { MarketplaceFacade } from '@fgb/core';

@Component({
  selector: 'fgb-products-page',
  templateUrl: './products-page.component.html',
  styleUrls: ['./products-page.component.scss'],
})
export class ProductsPageComponent implements OnInit {
  private marketplaceFacade = inject(MarketplaceFacade);

  ngOnInit() {
    this.marketplaceFacade.fetchMarketplaceItems();
  }
}
